import React from "react";
import Tag from "@/components/Tags/Tag";
import { cn } from "@/lib/utils";

export interface CareerKeySkillsProps {
  skills: string[];
  singleLine?: boolean;
  className?: string;
  titleClassName?: string;
}

export default function CareerKeySkills({
  skills,
  singleLine = true,
  className,
  titleClassName,
}: CareerKeySkillsProps) {
  if (skills.length === 0) {
    return null;
  }

  return (
    <div className={`mb-4 ${className || ""}`}>
      {singleLine ? (
        <div className="flex flex-row flex-wrap items-center gap-2">
          <p
            className={cn(
              "text-sm text-white font-semibold mb-0",
              titleClassName,
            )}
          >
            Key skills
          </p>
          {skills.map((skill, index) => (
            <Tag
              key={index}
              title={skill}
              color="fern"
              className="px-2 py-1 text-xs font-bold [border-radius:4px]"
            />
          ))}
        </div>
      ) : (
        <>
          <p
            className={cn(
              "text-sm text-white font-semibold mb-2",
              titleClassName,
            )}
          >
            Key skills
          </p>
          <div className="flex flex-row flex-wrap items-center gap-2">
            {skills.map((skill, index) => (
              <Tag
                key={index}
                title={skill}
                color="fern"
                borderless={true}
                className="px-2 py-1 text-xs font-bold [border-radius:4px]"
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
